<div class="badge-editor-container">
  <ngx-badge-events-list *ngIf="!embedded && currentStep === badgeEditorStep.EVENT_SELECTION" (eventSelected)="onEventSelected($event)"></ngx-badge-events-list>
  <ngx-badge-persona-list
    *ngIf="currentStep === badgeEditorStep.PERSONA_SELECTION"
    [personas]="personas"
    [selectedPersona]="selectedPersona"
    (personaSelected)="onPersonaSelected($event)"
    (backToEvents)="onBack(badgeEditorStep.EVENT_SELECTION)"
  >
  </ngx-badge-persona-list>
  <app-name-badge
    class="d-block w-100 h-100"
    *ngIf="currentStep === badgeEditorStep.BADGE_PREVIEW"
    [persona]="badgePersona"
    [badgeForm]="badgeForm"
    [variableElementsData]="variableElements"
    [parentVariableElementsData]="parentVariableElements"
    (onCancel)="onCancelTemplateSelection()"
    (backToPersonaSelection)="onBack(badgeEditorStep.PERSONA_SELECTION)"
  ></app-name-badge>
</div>
